import React from 'react';
import PropTypes from 'prop-types';
//import { isAdsNativeImplementation } from 'helpers/ads/constants';

class AdDiv extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      adCode: PropTypes.string,
      size: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
      divId: PropTypes.string,
      slotId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      smarked: PropTypes.bool,
    }).isRequired,
    addToQueue: PropTypes.func.isRequired,
    deviceType: PropTypes.string,
    className: PropTypes.string,
    callback: PropTypes.func,
    // adsCounter: PropTypes.number,
    prebid: PropTypes.bool,
    lazyload: PropTypes.bool,
    dfpParams: PropTypes.shape({}),
    dataset: PropTypes.shape({}),
  };
  static defaultProps = {
    deviceType: '',
    className: '',
    callback: undefined,
    prebid: false,
    // adsCounter: undefined,
    lazyload: false,
    dfpParams: undefined,
    dataset: {},
  };

  constructor(props) {
    super(props);
    // const { adsCounter = 1 } = props;
    const { divId, slotId, mgid } = props.data;
    const adDivId = divId || slotId || parseInt(Math.random() * 10e9, 10);
    const newAdObject = {
      ...props.data,
      deviceType: props.deviceType,
      divId: mgid ? divId : adDivId,
      callback: props.callback,
      prebid: props.prebid,
      dfpParams: props.dfpParams,
    };
    this.isRandomGenenratedDivPresent =
      typeof props.data.divId !== 'string' && !props.lazyload;
    this.state = {
      newAdObject,
      shouldAttachDivId: !this.isRandomGenenratedDivPresent,
    };
    if (
      // isAdsNativeImplementation(
      //   context.pathname,
      //   context.store.getState().isMobile,
      // ) &&
      this.props.addToQueue &&
      this.props.data
    ) {
      this.addedInConstructor = true;
      this.props.addToQueue(newAdObject);
    }
  }
  shouldComponentUpdate() {
    if (this.props.data?.smarked || this.props.isNewGam) {
      return false; // No rerender
    }
    if (this.props?.skipReRender) {
      return false; // No rerender
    }
    return true;
  }

  componentDidMount() {
    if (!this.addedInConstructor && this.props.addToQueue && this.props.data) {
      this.props.addToQueue(this.state.newAdObject);
    }
    if (!this.state.shouldAttachDivId) {
      this.setState({
        shouldAttachDivId: true,
      });
    }
  }

  componentWillUnmount() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data &&
      prevProps.data.adCode &&
      this.props.data &&
      this.props.data.adCode &&
      this.props.data.adCode !== prevProps.data.adCode
    ) {
      const { divId = parseInt(Math.random() * 10e9, 10) } = this.props.data;
      // const { adsCounter = 1 } = this.props;

      const newAdObject = {
        ...this.state.newAdObject,
        ...this.props.data,
        divId,
      };

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ newAdObject }, () => {
        if (this.props.addToQueue && this.props.data) {
          this.props.addToQueue({ ...this.state.newAdObject });
        }
      });
    }
  }

  adDivElem = (info, k) => (
    <div
      key={info.id + k}
      {...info}
      className={`adInv ${info.className}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: '' }}
      suppressHydrationWarning
      data-ua-type="2"
      data-sp-click="stpPgtn(event)"
      onClick={event => {
        window.stpPgtn(event);
      }}
    />
  );

  render() {
    if (this.state.newAdObject) {
      const { adCode, divId } = this.state.newAdObject;
      if (adCode) {
        return this.adDivElem(
          {
            ...this.props.dataset,
            id: this.state.shouldAttachDivId ? divId : undefined,
            className: this.props.className,
          },
          '',
        );
      }
      return null;
    }
    return null;
  }
}
// AdDiv.contextTypes = {
//   pathname: PropTypes.string.isRequired,
//   query: PropTypes.string.isRequired,
//   store: PropTypes.object.isRequired,
// };
export default AdDiv;
